// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","logo":"Home_logo__i5Rn4","cardContainer":"Home_cardContainer__IBaB6"};